class Cart {
  constructor() {
    this.cart();
  }
  cart = () => {};
}

export default Cart;
